interface VNodeClass {
  [id: string]: string
}

interface VNodeEvents {
  [id: string]: (...args: any[]) => any
}

interface VNodeProps {
  class?: VNodeClass
  on?: VNodeEvents
}

export default class VNode {
  public tag: string
  public props?: VNodeProps
  public children?: Array<VNode>

  constructor (tag = 'div', props = {}, children = []) {
    this.tag = tag
    this.props = props
    this.children = children
  }
}
